import React from 'react'
import { Typography, Box, Stack, Button } from '@mui/material'
import BodyPartImage from '../assets/icons/body-part.png'
import TargetImage from '../assets/icons/target.png'
import EquipmentImage from '../assets/icons/equipment.png'
import Zoom from 'react-reveal/Zoom';
function Details(ExerciseDetail) {
    const { bodyPart, gifUrl, name, target, equipment } = ExerciseDetail.ExerciseDetail;
    // console.log(ExerciseDetail.ExerciseDetail);
    const extraDetail = [
        {
            icon: BodyPartImage,
            name: bodyPart
        },
        {
            icon: TargetImage,
            name: target
        },
        {
            icon: EquipmentImage,
            name: equipment
        },
    ]
    return (
        <div>

            <Stack gap='60px' sx={{ flexDirection: { lg: 'row', p: '20px', alignItems: 'center' } }}>
                <Zoom>
                    <img src={gifUrl} alt={name} loading='lazy' className='detail-image' />
                </Zoom>
                <Stack sx={{ gap: { lg: '35px', xs: '20px' } }}>

                    <Typography variant='h3'> Steps {name}-:</Typography>
                    <Zoom>
                        {

                            ExerciseDetail.ExerciseDetail.instructions?.map((e) => (
                                <Typography variant='h6'>-: {e}</Typography>
                            ))
                        }
                    </Zoom>

                    {extraDetail?.map((item) => (
                        <Stack key={item.name} direction="row" gap="24px" alignItems="center">
                            <Button sx={{ background: '#fff2db', borderRadius: '50%', width: '100px' }} >
                                <img scr={BodyPartImage} alt={bodyPart} style={{ width: '50px', 'height': '50px' }} />
                            </Button>
                            <Typography textTransform='capitalize' variant='h6'>{item.name}</Typography>
                        </Stack>
                    ))}
                </Stack>
            </Stack>

        </div>
    )
}

export default Details